/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Address, IncludedResource } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Addresses<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags addresses
   * @name DeleteAddressesId
   * @summary 住所を削除する（ユーザーの住所一覧から非表示にする）
   * @request DELETE:/addresses/{id}
   */
  deleteAddressesId = (id: string, params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/addresses/${id}`,
      method: "DELETE",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name GetAddresses
   * @summary 登録されている住所を返す
   * @request GET:/addresses
   */
  getAddresses = (params: RequestParams = {}) =>
    this.request<
      {
        data: Address[];
        included?: IncludedResource[];
      },
      void
    >({
      path: `/addresses`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name GetAddressesAutocomplete
   * @summary 住所から郵便番号変換
   * @request GET:/addresses/autocomplete
   */
  getAddressesAutocomplete = (
    query: {
      /** 市区町村 */
      city: string;
      /** 都道府県 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Address[];
        included?: IncludedResource[];
      },
      void
    >({
      path: `/addresses/autocomplete`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name GetAddressesCurrent
   * @summary 現在有効な配送先を返す
   * @request GET:/addresses/current
   */
  getAddressesCurrent = (params: RequestParams = {}) =>
    this.request<
      {
        data: Address;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/addresses/current`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name GetAddressesLookup
   * @summary 郵便番号から住所を検索する
   * @request GET:/addresses/lookup
   */
  getAddressesLookup = (
    query: {
      /** 郵便番号 */
      postal_code: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Address[];
        included?: IncludedResource[];
      },
      any
    >({
      path: `/addresses/lookup`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name PostAddresses
   * @summary 住所を登録する
   * @request POST:/addresses
   */
  postAddresses = (
    data: {
      /** 市区町村と住所 */
      city_and_street: string;
      /**
       * 住所の種別
       * @default null
       */
      kind?: string;
      /** 氏名 */
      name: string;
      /**
       * 編集元のaddress_idを指定する
       * @default null
       */
      original_id?: string;
      /**
       * マンション名、部屋番号など
       * @default ""
       */
      others?: string;
      /**
       * 電話番号
       * @default null
       */
      phone_number?: string;
      /** 郵便番号 */
      postal_code: string;
      /**
       * プライマリとして登録する
       * @default "0"
       */
      primary?: "1" | "0";
      /**
       * 送り主の氏名
       * @default null
       */
      sender_name?: string;
      /** 都道府県 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Address;
        included?: IncludedResource[];
      },
      void
    >({
      path: `/addresses`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name PostAddressesPrimary
   * @summary 指定した住所IDをその人のプライマリ住所として登録する
   * @request POST:/addresses/primary
   */
  postAddressesPrimary = (
    data: {
      /** Address ID */
      address_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/addresses/primary`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name PostAddressesValidate
   * @summary 住所内容の正しさを検証する
   * @request POST:/addresses/validate
   */
  postAddressesValidate = (
    data: {
      /** 市区町村と住所 */
      city_and_street: string;
      /** 郵便番号 */
      postal_code: string;
      /** 都道府県 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/addresses/validate`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
}
